import i18next from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'owHeader', es);
i18next.addResourceBundle('en', 'owHeader', en);
i18next.addResourceBundle('pt', 'owHeader', pt);